import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsUser = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g>
        <path
          fill="currentColor"
          d="M23.4635658,22.9491863v-0.0093765c-0.0351601-4.1862984-3.2346554-7.5990944-7.1373367-7.5990944
		l-8.6491852-0.0023432l-0.0000029,0.0000019c-3.8909612,0-7.0834246,3.3963881-7.1373353,7.5662775v0.0093765
		c-0.0140632,0.0867271-0.0093764,0.1757965,0.016408,0.2625237v0.0093765
		c0.0117198,0.0328159,0.0234395,0.06563,0.0421908,0.0961018c0.0093763,0.0187511,0.0210961,0.0351582,0.0328159,0.0515671
		c0.009375,0.0140629,0.0210947,0.0304699,0.0328145,0.0445347c0.0093763,0.0140629,0.0210961,0.0304718,0.0328159,0.0445366
		s0.0210962,0.0234394,0.0328159,0.0351582c0.0164065,0.0117207,0.0328145,0.0234394,0.0492224,0.0351601
		c0.0140632,0.0093765,0.0257829,0.0187511,0.0421909,0.0257835h0.0093763
		c0.0421908,0.0234394,0.0890699,0.0421906,0.1382924,0.0515671h0.0093763c0.0679752,0.0140629,0.135949,0.0140629,0.2039242,0
		h21.6651535c0.0843811,0.016407,0.1711082,0.0093765,0.250803-0.0164089
		c0.0773506-0.0234394,0.1453247-0.06563,0.2039242-0.1218853l0.016407-0.0164089v-0.0093746
		c0.0117207-0.0117207,0.0210972-0.0234394,0.0328159-0.0351601l0.0093765-0.0093765
		c0.0093765-0.0117188,0.0164089-0.0234394,0.0234394-0.0351601v-0.0093746
		c0.0093765-0.0140648,0.0164089-0.0281277,0.0234394-0.0445366C23.4588776,23.1718616,23.4776287,23.0593529,23.4635658,22.9491863
		z M1.6062045,22.4499264c0.1617334-3.2698135,2.7986798-5.8739452,6.070837-5.9911423h8.6444969
		c3.2721577,0.117197,5.9091053,2.7213287,6.070837,5.9911423H1.6062045z"
        />
        <path
          fill="currentColor"
          d="M11.5820675,13.1209955c3.2721567,0.2297068,6.1106853-2.2361317,6.3403893-5.5059452
		c0.0187531-0.2765861,0.0187531-0.5555172,0-0.8344469c0.1125107-3.3893561-2.5338116-6.2302256-5.9208231-6.3614874
		C8.6122789,0.5480332,5.9659562,3.3912487,6.0761223,6.7806034C5.8464155,10.0527611,8.312254,12.8912878,11.5820675,13.1209955z
		 M12.0016336,1.5371815c2.7963352,0.1007897,4.9808989,2.4494305,4.8801107,5.2457657
		c0.1945477,2.6955457-1.8353157,5.0394979-4.5308609,5.2317023c-2.6955452,0.1945477-5.0394979-1.8353148-5.2317023-4.5308599
		c-0.016408-0.2343955-0.016408-0.4664474,0-0.7008424C7.0183916,3.9866118,9.2029552,1.6379712,12.0016336,1.5371815z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsUser;
